(function ($) {
  $(function () {
    if ($(".js-popup-modal").length) {
      if (!localStorage.getItem("show_popup")) {
        localStorage.setItem("show_popup", true);
      }

      if (localStorage.getItem("show_popup") === "true") {
        $(".js-popup-modal").iziModal({
          width: 800,
          overlay: true,
          overlayClose: true,
          overlayColor: "rgba(0, 0, 0, 0.4)",
          radius: "0",
        });

        $(".js-popup-modal").iziModal("open");

        $(document).on("closed", ".js-popup-modal", function (e) {
          localStorage.setItem("show_popup", false);
        });

        if ($(".js-popup-btn").length) {
          $(".js-popup-btn").on("click", function (e) {
            e.preventDefault();
            localStorage.setItem("show_popup", false);

            const url = $(this).attr("href");
            const target = $(this).attr("target");

            if (target) {
              window.open(url, "_blank");
            } else {
              document.location.href = url;
            }
          });
        }
      }
    }
  });
})(jQuery);
